import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { Check, Times } from '../../../components/Icon';
import { ButtonBar } from '../../../components/ButtonBar';
import { Loader } from '../../../components/Loader';
import { FormField } from '../../../components/FormFields';
import { HBox, VBox } from '../../../components/Box';
import { selectUserId, selectWorks } from '../../Api/selectors';
import { deleteVehicleProperty, hexonCreateAds, setVehicleProperties, setVehicleProperty } from '../actions';
import { REQUEST_VEHICLE, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import { selectUser } from '../../Users/selectors';
import { fetchUser } from '../../Users/actions';
import { getPropByName, getPropertyValueObjectByName } from '../../../utils/props';
import { getDate } from '../helpers';
import _ from 'lodash';
import { Well } from '../../../components/Well';
import { hexon_portals } from '../../../env';
import cn from 'classnames';
import styles from './CardHexon.module.css';

const Container = styled.div`
  font-size: 14px;
  margin: 10px auto;
  width: 100%;

  .button.inactive {
    opacity: 0.4;
  }
`;

const STATE = {
  isOpen: false,
  claim_remark: '',
  hexon_text1: '',
  hexon_text2: '',
};
/* eslint-disable react/prefer-stateless-function */
class VehicleHexonCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.vehicle?.user_changed_claim) {
      this.props.fetch(this.props.vehicle?.user_changed_claim, result => this.setState({ user: result }));
    }
    if (this.props.vehicle?.hexon_text1?.trim()?.length) {
      this.setState({ hexon_text1: this.props.vehicle?.hexon_text1 });
    }
    if (this.props.vehicle?.hexon_text2?.trim()?.length) {
      this.setState({ hexon_text2: this.props.vehicle?.hexon_text2 });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.vehicle?.user_changed_claim) {
      this.props.fetch(this.props.vehicle?.user_changed_claim, result => this.setState({ user: result }));
    }
  }

  get userChangedClaim() {
    let name = this.state.user ? getPropByName(this.state.user, 'name') : this.props.changedClaimUser?.name || '';

    let surname = this.state.user ? getPropByName(this.state.user, 'surname') : this.props.changedClaimUser?.surname || '';
    return `${name} ${surname}`;
  }

  get claimUpdatedAt() {
    const date = getPropertyValueObjectByName(this.props.vehicle, 'hexon_text1')?.updatedAt;
    const parsedDate = getDate(date, true);
    return parsedDate;
  }

  get canAdvertise() {
    let site_code = hexon_portals?.[0];
    if (!site_code) return false;
    let status = this.props.vehicle[`hexon_status_${site_code}`];
    return status != 1;
  }

  render() {
    const vehicle = this.props.vehicle;

    return (
      <Card style={{ width: '100%' }} className={cn('vehicle-info-card info-card data wide', styles.card)}>
        <Container>
          {this.props.works ? <Loader small /> : null}
          <h2 className="card-title mb-0 text-muted mb-2">{this.lbl('vehicle.hexon.extra_text')}</h2>

          <HBox vCenter className={styles.boxTextButton}>
            <FormField label={this.lbl('vehicle.hexon.text1')}>
            <textarea
              cols={20}
              style={{ resize: 'none', height: '200px', width: '98%' }}
              value={this.state.hexon_text1.replace(/\[br\]/g, '\n')}  
              onChange={e => {
                this.setState({
                  hexon_text1: e.target.value.replace(/\n/g, '[br]')  // Replace new lines with [br]
                });
              }}
            />
            </FormField>
            {this.state.hexon_text1 !== this.props.vehicle?.hexon_text1 && (
              <>
                <div className={styles.containerCheck}>
                  <Button className={styles.buttonCheck} small onClick={() => this.props.setInfo(this.state.hexon_text1)}>
                    <Check />
                  </Button>
                </div>

                <Button
                  className={styles.buttonTimes}
                  small
                  onClick={() => this.setState({ hexon_text1: this.props.vehicle?.hexon_text1 })}
                >
                  <Times />
                </Button>
              </>
            )}
          </HBox>

          <HBox vCenter className={styles.boxTextButton}>
            <FormField label={this.lbl('vehicle.hexon.text1')}>
              <textarea
                cols={20}
                style={{ resize: 'none', height: '200px', width: '98%' }}
                value={this.state.hexon_text2.replace(/\[br\]/g, '\n')}  
              onChange={e => {
                this.setState({
                  hexon_text2: e.target.value.replace(/\n/g, '[br]')  // Replace new lines with [br]
                });}}
              />
            </FormField>
            {this.state.hexon_text2 !== this.props.vehicle?.hexon_text2 && (
              <>
                <div className={styles.containerCheck}>
                  <Button className={styles.buttonCheck} small onClick={() => this.props.setInfo2(this.state.hexon_text2)}>
                    <Check />
                  </Button>
                </div>

                <Button
                  className={styles.buttonTimes}
                  small
                  onClick={() => this.setState2({ hexon_text2: this.props.vehicle?.hexon_text2 })}
                >
                  <Times />
                </Button>
              </>
            )}
          </HBox>

          {this.canAdvertise && (
            <Well>
              {this.state.activatingAllAds ? (
                <Loader small />
              ) : this.canAdvertise ? (
                <Button
                  className={styles.button}
                  onClick={() => {
                    this.setState({ activatingAllAds: true });
                    this.props.createMulti();
                  }}
                >
                  Zet advertenties aan
                </Button>
              ) : null}
            </Well>
          )}
        </Container>
      </Card>
    );
  }
}

VehicleHexonCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    works: selectWorks([`${REQUEST_VEHICLE_PROPERTY_UPDATE}-active_claim`, REQUEST_VEHICLE]),
    loggedInUserId: selectUserId(),
    changedClaimUser: selectUser(ownProps.vehicle?.user_changed_claim),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(id, callback) {
      dispatch(fetchUser(id, callback));
    },

    createMulti(callback) {
      dispatch(hexonCreateAds(ownProps.vehicle.id, hexon_portals, callback));
    },
    unsetValue() {
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'active_claim'));
    },
    setValue(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'active_claim', val));
    },
    setValue2(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'active_claim', val));
    },
    setInfo(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'hexon_text1', val));
    },
    setInfo2(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'hexon_text2', val));
    },
    setValues(claim, user, info = '', callback) {
      let props = info
        ? ['user_changed_claim', user, 'active_claim', claim, '', info]
        : ['user_changed_claim', user, 'active_claim', claim, '', ' '];
      dispatch(
        setVehicleProperties(
          ownProps.vehicle.id,
          _.chunk(props, 2).map(pair => ({
            propertyName: pair[0],
            propertyValue: pair[1],
          })),
          callback,
        ),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleHexonCard = compose(withConnect, withRouter)(VehicleHexonCardComp);
